import { Box } from './Box';
import {
  type PolymorphicProps,
  type AlignItems,
  type Display,
  type FlexDirection,
  type FlexDirectionShortcuts,
  type FlexWrap,
  type Grid,
  type GridShortcuts,
  type JustifyContent,
  type ResponsiveProperties,
  type CssProps,
  FluidProperties,
  Paddings,
  Margins,
  Gaps,
} from './types';
import { type ForwardedRef, forwardRef } from 'react';

type Props = PolymorphicProps<
  ResponsiveProperties<
    Omit<
      CssProps,
      keyof (Display & Grid & GridShortcuts & FlexDirection & AlignItems & JustifyContent & Paddings & Margins & Gaps)
    >
  > &
    (
      | ({ inline?: boolean } & ResponsiveProperties<{ display?: never }>)
      | ({ inline?: never } & ResponsiveProperties<{ display: 'none' | 'contents' | 'flex' | 'inline-flex' }>)
    ) &
    (
      | ({ row?: boolean } & ResponsiveProperties<{ direction?: never }>)
      | ({ row?: never } & ResponsiveProperties<FlexDirectionShortcuts>)
    ) &
    (
      | ({ wrap?: boolean } & ResponsiveProperties<{ flexWrap?: never }>)
      | ({ wrap?: never } & ResponsiveProperties<FlexWrap>)
    ) &
    (FluidProperties<Paddings> | ResponsiveProperties<Paddings>) &
    (FluidProperties<Margins> | ResponsiveProperties<Margins>) &
    (FluidProperties<Gaps> | ResponsiveProperties<Gaps>)
>;

export const Stack = forwardRef(function _Stack(
  { inline, row, direction, wrap, flexWrap, display, ...rest }: Props,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <Box
      display={inline ? 'inline-flex' : (display ?? 'flex')}
      direction={row ? 'row' : (direction ?? 'column')}
      flexWrap={wrap ? 'wrap' : flexWrap}
      ref={ref}
      {...rest}
    />
  );
});
